// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Nxko","right":"styles_right__27v3D"};